module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0136.f1ff75ec.jpg";